import { render, staticRenderFns } from "./CustomPaging.vue?vue&type=template&id=0472753a"
import script from "./CustomPaging.vue?vue&type=script&lang=js"
export * from "./CustomPaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports